import Icon from '@ant-design/icons';
import { Button } from 'antd';
import i18n from '@/i18n';
import React from 'react';
import IconSetting from '@/assets/images/page/icon-setting.react.svg?react';

export const TABLE_SETTING_CONFIG = {
  children: (<Button style={{ padding: '1px 10px' }}>
    <Icon style={{ fontSize: 14 }} component={IconSetting as any} alt='' /> {i18n.t('设置')}
  </Button>),
};
